import { IOnboarding } from '@sdk/contracts';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { sdk } from '@/services';

const UserOnboardingService = sdk.getService('UserOnboardingService');

export const useMutateUserOnboarding = () => {
  const queryClient = useQueryClient();
  const onSuccess = () => {
    queryClient.invalidateQueries({ queryKey: ['user-onboarding'] });
  };

  const { mutate: markContractAsSigned, isPending: isMarkingContractAsSigned } = useMutation({
    mutationFn: () => UserOnboardingService.markContractAsSigned(),
    onSuccess
  });

  const { mutate: finishUserOnboarding, isPending: isFinishingUserOnboarding } = useMutation({
    mutationFn: () => UserOnboardingService.finishUserOnboarding(),
    onSuccess
  });

  const { mutate: updateUserOnboarding, isPending: isUpdatingUserOnboarding } = useMutation({
    mutationFn: ({ userId, update }: { userId: string; update: Partial<IOnboarding> }) =>
      UserOnboardingService.updateUserOnboarding(userId, update),
    onSuccess
  });

  return {
    markContractAsSigned,
    finishUserOnboarding,
    updateUserOnboarding,
    isWorking: isMarkingContractAsSigned || isFinishingUserOnboarding || isUpdatingUserOnboarding
  };
};
